import React, { useEffect, useState } from 'react';
import {CssBaseline,Paper,Stepper,Step,StepLabel,Typography,CircularProgress,Divider,Button} from '@material-ui/core';
import {commerce} from '../../../lib/commerce'
import useStyles from './styles';
import { Link } from 'react-router-dom';
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';

const steps = ['Shipping Address','Payment Details'];

const Checkout = ({cart,order,onCaptureCheckout,error}) => {
    const [activeStep, setActiveStep] = useState(0);
    const [checkoutToken,setCheckoutToken] = useState(null)
    const [shippingData,setShippingData] = useState({});
    const classes = useStyles();

useEffect(() => {
    if (cart.id) {
      const generateToken = async () => {
        try {
          const token = await commerce.checkout.generateToken(cart.id, { type: 'cart' });

          setCheckoutToken(token);
        } catch {
         
        }
      };

      generateToken();
    }
  }, [cart]);

    const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep + 1)
    const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep -1)

    const next = (data) =>{
        setShippingData(data);
        nextStep()
    }

    let Confirmation = () => (order.customer ? (
      <>
        <div>
          <Typography variant="h5">Thank you for your purchase, {order.customer.firstname} {order.customer.lastname}!</Typography>
          <Divider className={classes.divider} />
          <Typography variant="subtitle2">Order ref: {order.customer_reference}</Typography>
        </div>
        <br />
        <Button component={Link} variant="outlined" type="button" to="/">Back to home</Button>
      </>
    ) : (
      <div className={classes.spinner}>
        <CircularProgress />
      </div>
    ));
  
    if (error) {
      Confirmation = () => (
        <>
          <Typography variant="h5">Thank you for your purchase😀</Typography>
          {/* <Typography variant="h5">Error: {error}</Typography> */}
          <br />
          <Button component={Link} variant="outlined" type="button" to="/">Back to home</Button>
        </>
      );
    }

    const Form = () => activeStep === 0
        ? <AddressForm checkoutToken={checkoutToken} next={next} />
        : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} onCaptureCheckout={onCaptureCheckout}/>
        
  return (
    <>
        <div className={classes.toobar}/>
        <main className={classes.layout}>
        <Paper className={classes.paper}>
            <Typography variant='h4' align='center'>Checkout</Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map((step)=>(
                    <Step key={step}>
                        <StepLabel>{step}</StepLabel>
                    </Step>
                    ))}
            </Stepper>
            {activeStep === steps.length ? <Confirmation/> : checkoutToken && <Form/>}
        </Paper>
        </main>
    </>
  )
}

export default Checkout